module.exports = __webpack_public_path__ + "static/img/end.e822dff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/end.png
// module id = rS+z
// module chunks = 12